import { getNewGameRecommendList } from '@/api/app';
const state = {
  newgameBannerList: [], // 新游推荐列表
  topBannerList: [], // 新游推荐顶部banner列表
  isFirstLogin: false, // 当天是否首次登陆
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
};

const actions = {
  // 获取新游推荐列表
  async getNewGameRecommendList({ state, commit }, data) {
    let r = {};
    try {
      r = await getNewGameRecommendList(data);
    } catch (error) {
      commit('CHANGE_STATE', {
        newgameBannerList: [],
        topBannerList: [],
        isFirstLogin: false,
      });
      console.log(error);
      return;
    }
    if (r.code !== 1 || !r.data.list) return;
    commit('CHANGE_STATE', {
      newgameBannerList: [...r.data.list],
      topBannerList: r.data.list.length && r.data.list.filter(item => item.banner_show_state == 1),
      isFirstLogin: r.data.first_login ? true : false,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
